module.exports = __webpack_public_path__ + "media/images/CHA-02-5347b3ed4eacb5ee1a7f1f8109f164cd.jpg";